export enum FileDocumentType {
    PayStub = 0,
    Tax = 1,
    Receipts = 2,
    Notes = 3,

    DonorAdp = 4,
    DonorMedChart = 5,
    DonorCTReport = 6,
    DonorRawTyping = 7,
    DonorCTRABO = 8,
    DonorHistoTyping = 9,
    DonorHistoAbo = 10,
    DonorSerology = 11,
    DonorVRLABO = 12,
    DonorVRLABOMol = 13,
    DonorVRLABOA2 = 14,
    DonorVRLHLA = 15,
    DonorCovidTest = 16,
    DonorPostTransplantFormsChecklists = 200,

    CmsGoodStanding = 17,
    DonorCenterAgreement = 18,
    RecipientCenterAgreement = 19,

    DsDependentCare = 40,
    DsDependentCompanion = 41,
    DsPaymentAssistance = 42,
    DsSelfEmployedAffidavit = 43,
    SsnVerification = 44,

    RecipientAbo = 60,
    RecipientDemo = 61,
    RecipientHistoTyping = 62,
    RecipientHistoAbo = 63,
    VoucherForm = 64,

    PsAboTyping = 74,

    CenterContract = 100,
    SrtrGraftSurvival = 101,
    SrtrPatientSurvival = 102,
    AllInAgreement = 103,
    BusinessAssociateAgreement = 104,
    DonorProtectionAddendum = 105,
    PartnerCenterAgreement = 106,
    DcnAgreement = 107,
    DonorShieldAgreement = 108,
    SalesTaxExemption = 109,

    OpoContract = 120,
    OpoTermsAndConditions = 121,
    OpoContractAddendum = 126,

    DonorShieldClaimHistory = 1000,
}


export const FileDocumentTypeDescription: { [key in FileDocumentType]: string } = {
    [FileDocumentType.PayStub]: '',
    [FileDocumentType.Tax]: '',
    [FileDocumentType.Receipts]: '',
    [FileDocumentType.Notes]: '',

    [FileDocumentType.DonorAdp]: '',
    [FileDocumentType.DonorMedChart]: 'NKR_DONOR_CHART',
    [FileDocumentType.DonorCTReport]: 'CT_REPORT',
    [FileDocumentType.DonorRawTyping]: 'RAW_TYPING',
    [FileDocumentType.DonorCTRABO]: 'CENTER_ABO',
    [FileDocumentType.DonorHistoTyping]: 'NKR_HIGH_RES_TISSUE',
    [FileDocumentType.DonorHistoAbo]: 'NKR_HISTO_ABO',
    [FileDocumentType.DonorSerology]: 'SEROLOGY',
    [FileDocumentType.DonorVRLABO]: 'DONOR_VRL_ABO',
    [FileDocumentType.DonorVRLABOMol]: 'DONOR_VRL_ABL_MOL',
    [FileDocumentType.DonorVRLABOA2]: 'DONOR_VRL_ABO_A2',
    [FileDocumentType.DonorVRLHLA]: 'DONOR_VRL_HLA',
    [FileDocumentType.DonorCovidTest]: 'DONOR_COVID_TEST',
    [FileDocumentType.DonorPostTransplantFormsChecklists]: 'DONOR_POST_TRANSPLANT_FORMS_CHECKLISTS',

    [FileDocumentType.CmsGoodStanding]: '',
    [FileDocumentType.DonorCenterAgreement]: '',
    [FileDocumentType.RecipientCenterAgreement]: 'RECIPIENT_CENTER_AGREEMENT',

    [FileDocumentType.DsDependentCare]: '',
    [FileDocumentType.DsDependentCompanion]: '',
    [FileDocumentType.DsPaymentAssistance]: '',
    [FileDocumentType.DsSelfEmployedAffidavit]: '',
    [FileDocumentType.SsnVerification]: '',

    [FileDocumentType.PsAboTyping]: '',

    [FileDocumentType.RecipientAbo]: 'RECIPIENT_ABO',
    [FileDocumentType.RecipientDemo]: 'RECIPIENT_DEMO',
    [FileDocumentType.RecipientHistoTyping]: 'RECIPIENT_HISTO_TYPING',
    [FileDocumentType.RecipientHistoAbo]: 'RECIPIENT_HISTO_TYPING',
    [FileDocumentType.VoucherForm]: 'VOUCHER_FORM',
    [FileDocumentType.CenterContract]: 'CENTER_CONTRACT',
    [FileDocumentType.SrtrGraftSurvival]: '',
    [FileDocumentType.SrtrPatientSurvival]: '',
    [FileDocumentType.AllInAgreement]: '',
    [FileDocumentType.BusinessAssociateAgreement]: '',
    [FileDocumentType.DonorProtectionAddendum]: '',
    [FileDocumentType.PartnerCenterAgreement]: '',
    [FileDocumentType.DcnAgreement]: '',
    [FileDocumentType.DonorShieldAgreement]: '',
    [FileDocumentType.SalesTaxExemption]: '',
    [FileDocumentType.OpoContract]: '',
    [FileDocumentType.OpoTermsAndConditions]: '',
    [FileDocumentType.OpoContractAddendum]: '',

    [FileDocumentType.DonorShieldClaimHistory]: ''
}